import './home.css';

const Home = () => (
  <div className="home-container">
    <h1>Welcome to Math Magicians App!</h1>
    <p>
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec in lacus
      molestie, dapibus risus in, mollis arcu. Donec eget ultricies lorem.
      Quisque ut nisi eu massa condimentum pellentesque. Curabitur mauris purus,
      posuere et ante ac, finibus porta lorem. Duis eget ultricies magna.
      Aliquam ac orci eu tortor sollicitudin tincidunt. Integer consequat, ante
      ac pulvinar hendrerit, odio urna pellentesque odio, placerat convallis
      elit augue nec nulla. Nunc leo purus, auctor at mauris ut, facilisis
      consequat neque. Aenean ac orci neque. Morbi ac ipsum a erat bibendum
      rhoncus. Nunc et mattis erat. Orci varius natoque penatibus et magnis dis
      parturient montes, nascetur ridiculus mus. Nunc faucibus sollicitudin
      semper. Donec quis elit sed ipsum dapibus ornare eget sit amet mauris.
    </p>
    <p>
      <br />
      Morbi blandit gravida turpis at congue. Donec vel leo pretium elit gravida
      eleifend. Duis efficitur turpis lorem, vitae cursus nisl sollicitudin ut.
      Vestibulum erat tellus, convallis ut est id, volutpat euismod libero. Ut
      eu tellus a nisi gravida facilisis et et dui. Cras mollis ullamcorper quam
      sed tempor. Etiam commodo a ante vitae sagittis. In cursus elit nec justo
      aliquet laoreet. Proin ut mi ipsum. Nullam non leo orci. Etiam pulvinar et
      nisl non consequat.
    </p>
  </div>
);

export default Home;
